import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Chip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid
} from '@mui/material';
import { useSystem } from '../context/SystemContext';

const SystemLogs = () => {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState({
    level: 'all',
    service: 'all',
    search: ''
  });

  useEffect(() => {
    // TODO: Load logs from API
    setLogs([
      {
        id: 1,
        timestamp: new Date(),
        level: 'INFO',
        service: 'Gateway',
        message: 'API request processed successfully'
      },
      {
        id: 2,
        timestamp: new Date(Date.now() - 60000),
        level: 'WARN',
        service: 'UserService',
        message: 'High memory usage detected'
      },
      {
        id: 3,
        timestamp: new Date(Date.now() - 120000),
        level: 'ERROR',
        service: 'Database',
        message: 'Connection timeout'
      }
    ]);
  }, []);

  const getLevelColor = (level) => {
    switch (level) {
      case 'ERROR':
        return 'error';
      case 'WARN':
        return 'warning';
      case 'INFO':
        return 'info';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Sistem Logları
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Ara"
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Seviye</InputLabel>
              <Select
                value={filter.level}
                label="Seviye"
                onChange={(e) => setFilter({ ...filter, level: e.target.value })}
              >
                <MenuItem value="all">Tümü</MenuItem>
                <MenuItem value="ERROR">Hata</MenuItem>
                <MenuItem value="WARN">Uyarı</MenuItem>
                <MenuItem value="INFO">Bilgi</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Servis</InputLabel>
              <Select
                value={filter.service}
                label="Servis"
                onChange={(e) => setFilter({ ...filter, service: e.target.value })}
              >
                <MenuItem value="all">Tümü</MenuItem>
                <MenuItem value="Gateway">Gateway</MenuItem>
                <MenuItem value="UserService">User Service</MenuItem>
                <MenuItem value="Database">Database</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button variant="contained" fullWidth>
              Filtrele
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Zaman</TableCell>
              <TableCell>Seviye</TableCell>
              <TableCell>Servis</TableCell>
              <TableCell>Mesaj</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.timestamp.toLocaleString()}</TableCell>
                <TableCell>
                  <Chip 
                    label={log.level} 
                    color={getLevelColor(log.level)}
                    size="small"
                  />
                </TableCell>
                <TableCell>{log.service}</TableCell>
                <TableCell>{log.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SystemLogs;
